import { render, staticRenderFns } from "./VInventoryItemHistory.vue?vue&type=template&id=70816b10"
import script from "./VInventoryItemHistory.vue?vue&type=script&lang=js"
export * from "./VInventoryItemHistory.vue?vue&type=script&lang=js"
import style0 from "./VInventoryItemHistory.vue?vue&type=style&index=0&id=70816b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports